import React, {useState} from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMagnifyingGlass,
  faXmark,
  faTruck,
  faCartShopping,
  faMoneyBillWave,
  faCommentsDollar,
  faShop,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import formatAssetNameForSelect from '../../utils/formatAssetName';

import { Link } from 'app/src/utils/routing';
import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

const Container = styled(View)`
  flex-direction: row;
  column-gap: 10px;
  margin: 5px;
`;

const Name = styled(View)`
  width: 300px;
`;

const NameText = styled(Text)`
  font-weight: 600;
`;

const Detail = styled(View)`
  width: fit-content;
`;

const AssetResult = ({ result }) => {
  return (
    <Container>
      <Detail>
        <Text>
          {getResultLabel(result)}
        </Text>
      </Detail>
    </Container>
  );
};

const InputOptionResult = ({ result }) => {
  return (
    <Container>
      <Detail>
        <Text>
          {result.label}
        </Text>
      </Detail>
    </Container>
  );
};

const getResultLabel = (resultData) => {
  switch(resultData.__typename) {
    case 'Asset':
      return `${resultData.vin} | ${resultData.stockNumber} | ${resultData.seller?.name} | ${formatAssetNameForSelect(resultData)}`
      break;
    case 'InputOption':
      return resultData.label;
      break;
    default:
      break;
  }
}

const COMPONENT_MAP = {
  Asset: AssetResult,
  InputOption: InputOptionResult,
};

const Result = ({
  result, setTerm, setValue, name, setClickedResult, resourceType, setResource
}) => {
  const ResultLink = COMPONENT_MAP[result.__typename];

  return (
    <Pressable
      onPress={() => {
        if(result.__typename === 'InputOption') {
          setValue(result.type, result.label);
        }else {
          setValue(`${resourceType}Id`, result.id);
        }
        if(setResource) {
          setResource(result)
        }
        setClickedResult(result);
        setTerm('')
      }}
      style={state => (
        {
          backgroundColor: state.hovered ? 'lightgray' : 'none'
        }
      )}
    >
      <ResultLink result={result} />
    </Pressable>
  );
};

export default Result;
